<!--
 * www.cloudscope.cn
 * Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author:liuc
 * @LastEditors: Please set LastEditors
 * @Description: 查询页面机构
-->
<template>
    <!-- 承担单位 Dialog: Begin -->
    <el-dialog
        title="单位选择"
        :visible.sync="isTree"
        custom-class="mod-dialog"
        append-to-body
        :before-close="close"
        width="550px"
    >
        <div class="main-contain">
            <div class="tree">
                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                <el-tree
                    :data="data"
                    node-key="id"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    @node-click="handleNodeClick"
                    :filter-node-method="filterNode"
                    :default-checked-keys="checkedKeys"
                    :default-expanded-keys="expandedKeys"
                    :highlight-current="true"
                    ref="tree2"
                ></el-tree>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" style="width:72px" type="info" @click="close">取消</el-button>
            <el-button size="mini" style="width:72px" type="primary" @click="addPage">确定</el-button>
        </span>
    </el-dialog>
    <!-- 承担单位 Dialog: Begin -->
</template>

<script>
export default {
    components: {},
    props: ['isTree', 'ommitmentUnit', 'selectUnit'],
    data () {
        return {
            dialogVisible: false,
            data: [],
            defaultProps: {
                children: 'childList',
                label: 'name'
            },
            unitSelectionId: 583720153288540160,
            unitSelectionName: '全部',
            unitSelectionChileList: [],
            unitSelectionType: 0,
            checkedKeys: [],
            expandedKeys: ['583720153288540160'],
            filterText: ''
        };
    },
    watch: {
        filterText (val) {
            this.$refs.tree2.filter(val);
        }
    },
    mounted () {
        this.getData();
        this.$nextTick(() => {
            if (this.ommitmentUnit) {
                var childData = this.$refs.tree2.getNode(this.ommitmentUnit)
                    .data;
                let parList = [
                    {
                        id: childData.id,
                        name: childData.name,
                        parentId: childData.parentId
                    }
                ];
                let count = 1;
                for (let index = 0; index < count; index++) {
                    if (parList[parList.length - 1].parentId != 0) {
                        let parentData = this.$refs.tree2.getNode(
                            parList[parList.length - 1].parentId
                        ).data;
                        parList.push({
                            id: parentData.id,
                            name: parentData.name,
                            parentId: parentData.parentId
                        });
                        count++;
                    } else {
                        break;
                    }
                }
                var list1 = [];
                var list2 = [];
                for (var i in parList) {
                    if (i == 0) {
                        list1.push(parList[i].id);
                        this.subjectSelectionName = parList[i].name;
                        this.subjectSelectionId = parList[i].id;
                    } else {
                        list2.push(parList[i].id);
                    }
                }
                this.checkedKeys = JSON.parse(JSON.stringify(list1));
                this.expandedKeys = JSON.parse(JSON.stringify(list2));
                this.$refs.tree2.setCurrentKey(this.checkedKeys[0]);
            }
        });
    },
    methods: {
        /**
         * @author: liuc
         * @description:关闭弹窗
         * @param {}
         */
        close () {
            this.dialogVisible = false;
            this.$emit('hideTree');
        },
        /**
         * @author: liuc
         * @description:选中处理
         * @param {data} 选中的机构数据
         */
        handleNodeClick (data) {
            this.unitSelectionId = data.id;
            // this.unitSelectionName= data.name;

            let parList = [
                {
                    name: data.name,
                    parentId: data.parentId
                }
            ];
            let count = 1;
            for (let index = 0; index < count; index++) {
                if (
                    parList[parList.length - 1].parentId != '583720153288540160'
                ) {
                    let parentData = this.$refs.tree2.getNode(
                        parList[parList.length - 1].parentId
                    ).data;
                    parList.push({
                        name: parentData.name,
                        parentId: parentData.parentId
                    });
                    count++;
                } else {
                    break;
                }
            }
            let nameStr = '';
            for (const key in parList) {
                if (key == 0) {
                    nameStr += parList[key].name;
                } else {
                    nameStr = parList[key].name + '/' + nameStr;
                }
            }
            this.unitSelectionName = nameStr;
            this.unitSelectionChileList = data.childList;
            this.unitSelectionType = data.type;
        },
        /**
         * @author: liuc
         * @description:页面传值
         * @param {}
         */
        addPage () {
            let unit = {};
            if (this.unitSelectionId == 583720153288540160) {
                // debugger
                unit = {
                    name: '全部',
                    id: this.unitSelectionId,
                    type: 1
                };
            } else {
                unit = {
                    name: this.unitSelectionName,
                    id: this.unitSelectionId,
                    childList: this.unitSelectionChileList,
                    type: this.unitSelectionType
                };
            }
            this.dialogVisible = false;
            this.$emit('addPage', unit);
        },
        /**
         * @author: liuc
         * @description:
         * @param {}:
         */
        async getData () {
            // 承担单位树
            let unitTree;
            if (this.selectUnit == 'all') {
                // 获取所有机构
                unitTree = await this.$api.OrganManagement.groupTree();
            } else {
                // 获取类型为“公司”的机构
                unitTree = await this.$api.OrganManagement.groupTreeByType();
            }
            this.data = unitTree.data;
        },
        /**
         * @author: liuc
         * @description: 树的搜索
         * @param {value} 输入的内容
         * @param {data} 所有机构数数据
         */
        filterNode (value, data) {
            if (!value) return true;
            if (data.name) {
                return data.name.indexOf(value) !== -1;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.tree {
    height: 36vh;
    overflow: auto;
    box-sizing: border-box;
    width: 100%;
    flex: 1;
    .el-tree {
        min-width: 100%;
        display: inline-block !important;
    }
}
</style>



// WEBPACK FOOTER //
// ./src/components/UnitTree.vue